export const FETCH_COMMUNICATION_WAYS_REQUEST = "FETCH_COMMUNICATION_WAYS_REQUEST";
export const CREATE_COMMUNICATION_WAYS_REQUEST = "CREATE_COMMUNICATION_WAYS_REQUEST";
